import { svg } from "lit";
const icon = svg `<path d="M11.2692 38.731H19.0577V26.481H28.9422V38.731H36.7307V19.6349L23.9999 10.0388L11.2692 19.6285V38.731ZM9 41.0002V18.5003L23.9999 7.21191L38.9999 18.5003V41.0002H26.673V28.7502H21.3268V41.0002H9Z" fill="currentColor"/>`;
export default icon;
